import React, { useState, lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

import * as api from './api';
import { useQuery } from 'react-query';
import { AnimatePresence } from 'framer-motion';
import LoadingSpinner from '../components/LoadingSpinner';
import Error from '../components/Error';
import { TAllData, TAnswers, TParams } from './types';

const Navigation = lazy(() => import('../components/Navigation'));
const Home = lazy(() => import('../components/Home'));
const Chapter = lazy(() => import('../components/Chapter'));
const Snack = lazy(() => import('../components/Snack'));

const Routing = (props: { servicecheckAccess: boolean; resultUrl: string; yearTwo: boolean; erMedlem: boolean; pensionsAlder: number; }) => {

	const { data, isLoading, isError } = useQuery<TAllData>('allData', () => api.getData('AarligtServicetjek'));
	const history = useHistory();
	const { resultUrl, servicecheckAccess, yearTwo, erMedlem, pensionsAlder } = props;
	const [navParams, setNavParams] = useState<TParams>({ chapter: '0', chapterTitle: '', page: '0', show: false, prev: null, variant: 'down' });
	const [answers, setAnswers] = useState<TAnswers[]>([]);
	const [y2answer, setY2answer] = useState(true);
	const [touchStartX, setTouchStartX] = useState<number>(0);
	const [touchEndX, setTouchEndX] = useState<number>(0);
	const distanceX = touchStartX - touchEndX;
	const minSwipeDistance = 150;

	const onTouchStart = (e: React.TouchEvent) => {
		setTouchEndX(0);
		setTouchStartX(e.targetTouches[0].clientX);
	};

	const onTouchMove = (e: React.TouchEvent) => setTouchEndX(e.targetTouches[0].clientX);

	const onTouchEnd = () => {
		if (!touchStartX || !touchEndX) {
			return;
		}

		const rightSwipe = distanceX < -minSwipeDistance;

		if (rightSwipe && navParams.prev) {
			setNavParams({ ...navParams, variant: 'up' });
			history.push(navParams.prev);
		}
	};

	if (isLoading) {
		return <div className="lhp-main"><LoadingSpinner /></div>;
	}

	if (isError || !data) {
		return <Error />;
	}

	return (
		<Suspense fallback={ <div className="lhp-main"><LoadingSpinner /></div> }>
			<Navigation
				setNavParams={ setNavParams }
				navParams={ navParams }
				allData={ data }
			/>
			<AnimatePresence>
				<main onTouchStart={ onTouchStart } onTouchMove={ onTouchMove } onTouchEnd={ onTouchEnd } className="lhp-main">
					<Switch>
						<Route exact path="/">
							<Home
								setNavParams={ setNavParams }
								navParams={ navParams }
								servicecheckAccess={ servicecheckAccess }
								allData={ data }
								answers={ answers }
								setAnswers={ setAnswers }
								setY2answer={ setY2answer }
								isYearTwo={ yearTwo }
							/>

						</Route>
						<Route exact path="/kapitel/:chapterId">
							<Chapter
								setNavParams={ setNavParams }
								setAnswers={ setAnswers }
								navParams={ navParams }
								answers={ answers }
								erMedlem={ erMedlem }
								resultUrl={ resultUrl }
								allData={ data }
								y2answer={ y2answer }
								servicetype={ 'AarligtServicetjek' }
							/>

						</Route>

						<Route exact path="/kapitel/:chapterId/side/:pageId">
							<Chapter
								setNavParams={ setNavParams }
								setAnswers={ setAnswers }
								navParams={ navParams }
								answers={ answers }
								resultUrl={ resultUrl }
								allData={ data }
								y2answer={ y2answer }
								servicetype={ 'AarligtServicetjek' }
							/>
						</Route>

						<Route exact path="/kapitel/:chapterId/side/:pageId/snack" >
							<Snack
								setNavParams={ setNavParams }
								navParams={ navParams }
								answers={ answers }
								btnText={ 'Næste' }
								allData={ data }
								servicetype={ 'AarligtServicetjek' }
								resultUrl={ resultUrl }
								pensionsAlder={ pensionsAlder }
							/>

						</Route>
					</Switch>
					<div id="portal" />
				</main>
			</AnimatePresence>
		</Suspense>
	);
};

export default Routing;